import {defineStore} from "pinia";
import environment from "@/environment";
import useCrudStore from "@/store/composables/crud";
import {useSettingsStore} from "@/store/settings";
import {computed, ref} from "vue";
import http from "@/tools/http-client";

export const useAuthStore
    = defineStore('authStore', () => {

    const initialized = ref(false);
    const crud = useCrudStore(
        environment.appConfig.baseApiUrl + "auth/login"
    );
    const settingsStore = useSettingsStore();

    const userId = computed(() => {
       return settingsStore.user.id;
    });

    const userName = computed(() => {
        return settingsStore.user.user_name;
    });

    async function initStore() {
        await settingsStore.loadSetting();
        initialized.value = true;
    }

    async function doLogin(user, password) {
        crud.startLoading();
        try {
            const params = {
                user_name: user,
                password,
            };
            const resp = await http.post(crud.endpoint.value, params);
            if(resp.data.status !== 'success') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            await  settingsStore.clearData();
            await settingsStore.loadSetting();
        } catch (e) {
            crud.setError(e);
        }
    }
    async function doLogout() {
        await settingsStore.clearData();
        await http.post(environment.appConfig.baseApiUrl + "auth/logout");
        await settingsStore.loadSetting();
    }
    return {
        ...crud,
        doLogin,
        doLogout,
        initStore,
        userId,
        userName,
        initialized
    }
});
